var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.042 3.025c.6.6.93 1.398.93 2.247 0 .85-.33 1.648-.93 2.248-.6.6-1.399.931-2.248.931-.849 0-1.647-.33-2.247-.93-.6-.601-.931-1.4-.931-2.249 0-.849.33-1.647.93-2.247.6-.6 1.4-.931 2.248-.931.85 0 1.648.33 2.248.93zM7.794 1a4.272 4.272 0 100 8.545 4.272 4.272 0 000-8.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.36 16.054a.546.546 0 01-.545-.508c-.235-3.352-2.774-6-5.861-6-3.088 0-5.627 2.648-5.861 6A.546.546 0 111 15.466a8.097 8.097 0 01.522-2.355 7.652 7.652 0 011.483-2.414 6.954 6.954 0 012.216-1.64 6.44 6.44 0 012.732-.605 6.44 6.44 0 012.731.605 6.949 6.949 0 012.216 1.64 7.653 7.653 0 011.483 2.414c.29.753.465 1.543.522 2.356a.547.547 0 01-.546.587z"
  }))));
}
export default SvgAccountManage;